import Register from './Register';

const ActivateAccount = () => <Register mode="activation" />;

export default ActivateAccount;
